import React, { useEffect, useRef, useState } from "react";

/**
 * Animated count-up number.
 * value: target number
 * decimals: decimal places to show
 * prefix / suffix: optional strings
 * duration: ms
 */
export default function AnimatedNumber({
  value = 0,
  decimals = 0,
  prefix = "",
  suffix = "",
  duration = 1200,
  className = "",
  "data-testid": testId,
}) {
  const [display, setDisplay] = useState(0);
  const startRef = useRef(null);
  const rafRef = useRef(null);
  const prevValueRef = useRef(0);

  useEffect(() => {
    const from = prevValueRef.current;
    const to = Number(value) || 0;
    startRef.current = null;

    const step = (ts) => {
      if (startRef.current == null) startRef.current = ts;
      const p = Math.min(1, (ts - startRef.current) / duration);
      // easeOutCubic
      const eased = 1 - Math.pow(1 - p, 3);
      const current = from + (to - from) * eased;
      setDisplay(current);
      if (p < 1) {
        rafRef.current = requestAnimationFrame(step);
      } else {
        prevValueRef.current = to;
      }
    };

    rafRef.current = requestAnimationFrame(step);
    return () => cancelAnimationFrame(rafRef.current);
  }, [value, duration]);

  const formatted = display.toLocaleString(undefined, {
    minimumFractionDigits: decimals,
    maximumFractionDigits: decimals,
  });

  return (
    <span className={`font-display font-bold tabular-num ${className}`} data-testid={testId}>
      {prefix}
      {formatted}
      {suffix}
    </span>
  );
}
